var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { staticClass: "task-form-container mt-3", attrs: { row: "", wrap: "" } },
    [
      _c(
        "input-field",
        {
          attrs: {
            label: _vm.$tc("Template", 1),
            value: _vm.taskTemplate,
            "variable-name": "tasksTemplates",
            "input-type": "other",
            size: "medium"
          }
        },
        [
          _c("treeselect", {
            staticClass: "form-input-select",
            attrs: {
              options: _vm.taskTemplateOptions,
              "load-options": _vm.loadTasksTemplateOptions,
              normalizer: _vm.taskTemplateNormalizer,
              "value-format": "object",
              disableFuzzyMatching: ""
            },
            on: { input: _vm.updateTaskWithTemplate },
            model: {
              value: _vm.taskTemplate,
              callback: function($$v) {
                _vm.taskTemplate = $$v
              },
              expression: "taskTemplate"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("input-field", {
        attrs: {
          label: _vm.$t("Title"),
          "variable-name": "title",
          "input-type": "text",
          size: "medium",
          required: ""
        },
        model: {
          value: _vm.newTask.title,
          callback: function($$v) {
            _vm.$set(_vm.newTask, "title", $$v)
          },
          expression: "newTask.title"
        }
      }),
      _vm._v(" "),
      _c(
        "input-field",
        {
          attrs: {
            label: _vm.$tc("Assignee", 1),
            value: _vm.newTask.user_assignee_id,
            "variable-name": "user_assignee_id",
            "input-type": "other",
            size: "small"
          }
        },
        [
          _c("treeselect", {
            staticClass: "form-input-select",
            attrs: {
              options: _vm.userOptions,
              "disable-branch-nodes": true,
              "value-consists-of": "LEAF_PRIORITY",
              disableFuzzyMatching: ""
            },
            model: {
              value: _vm.newTask.user_assignee_id,
              callback: function($$v) {
                _vm.$set(_vm.newTask, "user_assignee_id", $$v)
              },
              expression: "newTask.user_assignee_id"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "input-field",
        {
          attrs: {
            label: _vm.$tc("Dependency", 2),
            value: _vm.newTask.dependencies,
            "input-type": "other",
            size: "medium"
          }
        },
        [
          _c("treeselect", {
            staticClass: "form-input-select",
            attrs: {
              options: _vm.dependencyOptions,
              multiple: "",
              disableFuzzyMatching: ""
            },
            model: {
              value: _vm.newTask.dependencies,
              callback: function($$v) {
                _vm.$set(_vm.newTask, "dependencies", $$v)
              },
              expression: "newTask.dependencies"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "input-field",
        {
          attrs: {
            label: _vm.$t("ApprovalType"),
            "input-type": "other",
            size: "small",
            value: _vm.newTask.auto_approval
          }
        },
        [
          _c("treeselect", {
            staticClass: "form-input-select",
            attrs: {
              value: _vm.newTask.auto_approval,
              options: _vm.approvalType
            },
            on: {
              input: function($event) {
                return _vm.updateTaskApproval($event)
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("input-field", {
        attrs: {
          label: _vm.$t("ScheduledFor"),
          "variable-name": "scheduled_date",
          "input-type": "datetime",
          size: "small",
          max: _vm.activityDate,
          min: _vm.dateNow
        },
        model: {
          value: _vm.newTask.scheduled_date,
          callback: function($$v) {
            _vm.$set(_vm.newTask, "scheduled_date", $$v)
          },
          expression: "newTask.scheduled_date"
        }
      }),
      _vm._v(" "),
      _c("input-field", {
        attrs: {
          label: _vm.$t("Cost"),
          "variable-name": "cost",
          "input-type": "number",
          size: "small"
        },
        model: {
          value: _vm.newTask.cost,
          callback: function($$v) {
            _vm.$set(_vm.newTask, "cost", $$v)
          },
          expression: "newTask.cost"
        }
      }),
      _vm._v(" "),
      _c("input-field", {
        attrs: {
          label: _vm.$tc("TimeEstimation", 1),
          "variable-name": "type",
          "input-type": "number",
          size: "small",
          "field-disabled": false
        },
        model: {
          value: _vm.newTask.execution_time,
          callback: function($$v) {
            _vm.$set(_vm.newTask, "execution_time", $$v)
          },
          expression: "newTask.execution_time"
        }
      }),
      _vm._v(" "),
      _c("input-field", {
        attrs: {
          label: _vm.$t("Description"),
          "variable-name": "description",
          "input-type": "textarea",
          size: "medium"
        },
        model: {
          value: _vm.newTask.description,
          callback: function($$v) {
            _vm.$set(_vm.newTask, "description", $$v)
          },
          expression: "newTask.description"
        }
      }),
      _vm._v(" "),
      _vm.newTask.type === "mixed"
        ? _c(
            "div",
            { staticClass: "pa-3 text-width" },
            [
              _c("Mixed", {
                attrs: { task: _vm.newTask },
                on: {
                  addItems: _vm.addItem,
                  editItems: _vm.editItem,
                  removeItem: _vm.removeItem
                }
              }),
              _vm._v(" "),
              _c(
                "v-alert",
                {
                  staticClass: "mt-3",
                  attrs: {
                    value: _vm.disableSave,
                    type: "error",
                    transition: "scale-transition"
                  }
                },
                [_vm._v("\n      " + _vm._s(_vm.$t("addItemAlert")) + "\n    ")]
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-16c69768", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-16c69768","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/_SpecialTabs/Activities/TaskCreate/TaskCreateForm.vue
// module id = null
// module chunks = 